import { Pipe, PipeTransform } from '@angular/core'
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'
import { getDate, getMonth, getYear } from 'date-fns'

@Pipe({
  name: 'dateStruct',
  pure: true,
})
export class DateStructPipe implements PipeTransform {
  transform(value: Date | string | number | null | undefined, shouldDefaultToToday = false): NgbDateStruct | undefined  {
    if (value != null || shouldDefaultToToday) {
      const d = value ?? new Date()
      return { year: getYear(d), month: getMonth(d) + 1, day: getDate(d) }
    } else {
      return undefined
    }
  }
}
